import React, { useState, useEffect } from 'react';
import axios from "axios";
import Cookies from 'js-cookie';
import { handleLoginPopup } from '../../redux/slice/userSlice';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import VerifiedIcon from "@mui/icons-material/Verified";
import PhoneIcon from "@mui/icons-material/Phone";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

// Material Icons
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import WorkIcon from '@mui/icons-material/Work';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import FlightIcon from '@mui/icons-material/Flight';
import EngineeringIcon from '@mui/icons-material/Engineering';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import SecurityIcon from '@mui/icons-material/Security';
import AppsIcon from '@mui/icons-material/Apps';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import heroBackground from "../../assets/image/png/daas (1).jpg"
import CancelIcon from "@mui/icons-material/Cancel";

function DaasMarketplace() {
    const token = Cookies.get("token");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [services, setServices] = useState([]);
    const [projects, setProjects] = useState([]);
    const [pilots, setPilots] = useState([]);
    const [userId, setUserId] = useState('');

    const [loading, setLoading] = useState({
        services: true,
        projects: true,
        pilots: false
    });
    const [error, setError] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('All');
    const [priceRange, setPriceRange] = useState([0, 7500000]);
    const [sortOption, setSortOption] = useState('newest');
    const [showFilters, setShowFilters] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        address: '',
        offeredPrice: ''
    });
    const [selectedServiceId, setSelectedServiceId] = useState(null);
    const [selectedServiceType, setSelectedServiceType] = useState('');
    const [activeTab, setActiveTab] = useState('all');

    const [showPilotEnquiry, setShowPilotEnquiry] = useState(false);
const [selectedPilot, setSelectedPilot] = useState(null);
const [pilotEnquiryLoading, setPilotEnquiryLoading] = useState(false);

const [pilotEnquiryForm, setPilotEnquiryForm] = useState({
    name: "",
    mobileNumber: "",
    email: "",
    address: "",
    description: "",
});

const handlePilotEnquiry = (pilot) => {
    setSelectedPilot(pilot);

    setPilotEnquiryForm({
        name: "",
        mobileNumber: "",
        email: "",
        address: "",
        description: "",
    });

    setShowPilotEnquiry(true);
};

const handlePilotEnquiryChange = (e) => {
    const { name, value } = e.target;

    setPilotEnquiryForm((prev) => ({
        ...prev,
        [name]: value,
    }));
};

const submitPilotEnquiry = async (e) => {
    e.preventDefault();

    if (!selectedPilot?._id) {
        toast.error("Pilot information is missing.");
        return;
    }

    try {
        setPilotEnquiryLoading(true);

        const payload = {
            pilotId: selectedPilot._id,
            name: pilotEnquiryForm.name.trim(),
            mobileNumber: pilotEnquiryForm.mobileNumber.trim(),
            email: pilotEnquiryForm.email.trim(),
            address: pilotEnquiryForm.address.trim(),
            description: pilotEnquiryForm.description.trim(),
        };

        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/pilot-enquiry`,
            // `http://localhost:6002/pilot-enquiry`,
            payload
        );

        if (response.data.status === "success") {
            toast.success(
                "Enquiry submitted successfully. Our representative will contact you soon."
            );

            setShowPilotEnquiry(false);
            setSelectedPilot(null);

            setPilotEnquiryForm({
                name: "",
                mobileNumber: "",
                email: "",
                address: "",
                description: "",
            });
        } else {
            toast.error(
                response.data.message || "Failed to submit enquiry."
            );
        }

    } catch (error) {
        console.error("Pilot enquiry error:", error);

        toast.error(
            error.response?.data?.message ||
            "Something went wrong. Please try again."
        );
    } finally {
        setPilotEnquiryLoading(false);
    }
};

    // Fetch Pilots
    const fetchPilots = async () => {
    try {
        setLoading(prev => ({
            ...prev,
            pilots: true
        }));

        const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/getAllPilot?page=1&limit=3`
        );

        if (response.data.status === "success") {
            setPilots(response.data.data.data || []);
        } else {
            setPilots([]);
        }

    } catch (error) {
        console.error("Error fetching pilots:", error);
        setPilots([]);
    } finally {
        setLoading(prev => ({
            ...prev,
            pilots: false
        }));
    }
};

    useEffect(() => {
        const storedUserId = Cookies.get("userId");
        if (storedUserId) {
            setUserId(storedUserId);
        }
    }, []);

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const response = await axios.get(process.env.REACT_APP_API_URL + "/allDroneServices");
                setServices(response.data.services);
                setLoading(prev => ({ ...prev, services: false }));
            } catch (err) {
                console.error(err);
                setError('Failed to fetch services');
                setLoading(prev => ({ ...prev, services: false }));
            }
        };

        const fetchProjects = async () => {
            try {
                const response = await axios.get(process.env.REACT_APP_API_URL + "/getAllProjects");
                setProjects(response.data.projects || response.data);
                setLoading(prev => ({ ...prev, projects: false }));
            } catch (err) {
                console.error(err);
                setError('Failed to fetch projects');
                setLoading(prev => ({ ...prev, projects: false }));
            }
        };

        fetchServices();
        fetchProjects();
    }, []);

    const filteredServices = Array.isArray(services)
        ? services.filter(service => {
            const title = service.serviceTitle?.toLowerCase() || '';
            const vendor = service.vendorId || '';
            const category = service.serviceType;
            const price = service.pricePerUnit;

            const matchesSearch =
                title.includes(searchQuery.toLowerCase()) || 
                vendor.includes(searchQuery.toLowerCase());

            const matchesCategory =
                selectedCategory === 'All' ||
                (selectedCategory === 'Others'
                    ? !['Rental', 'Inspection', 'Project', 'Aerial Survey', 'Crop Spraying', 'Crop Monitoring', 'Photography', 'Surveillance'].includes(category)
                    : category === selectedCategory);

            const matchesPriceRange =
                price >= priceRange[0] && price <= priceRange[1];

            return matchesSearch && matchesCategory && matchesPriceRange;
        })
        : [];

    const filteredProjects = Array.isArray(projects)
        ? projects.filter(project => {
            const title = project.projectTitle?.toLowerCase() || '';
            const vendor = project.projectOwnerId || '';
            const price = project.budget;

            const matchesSearch =
                title.includes(searchQuery.toLowerCase()) || 
                vendor.includes(searchQuery.toLowerCase());

            const matchesPriceRange =
                price >= priceRange[0] && price <= priceRange[1];

            return matchesSearch && matchesPriceRange;
        })
        : [];

    const sortedServices = [...filteredServices].sort((a, b) => {
        if (sortOption === 'price-low') return a.pricePerUnit - b.pricePerUnit;
        if (sortOption === 'price-high') return b.pricePerUnit - a.pricePerUnit;
        return 0;
    });

    const sortedProjects = [...filteredProjects].sort((a, b) => {
        if (sortOption === 'price-low') return a.budget - b.budget;
        if (sortOption === 'price-high') return b.budget - a.budget;
        return 0;
    });

    const handleApplyNow = (serviceId, type) => {
        if (!token) {
            dispatch(handleLoginPopup(true));
            return;
        }
        setSelectedServiceId(serviceId);
        setSelectedServiceType(type);
        setShowModal(true);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmitApplication = async (e) => {
        e.preventDefault();

        try {
            const endpoint = selectedServiceType === 'service' 
                ? process.env.REACT_APP_API_URL + "/applyService" 
                : process.env.REACT_APP_API_URL + "/applyProject";
            
            const payload = selectedServiceType === 'service'
                ? {
                    serviceId: selectedServiceId,
                    vendorId: services.find(s => s._id === selectedServiceId)?.vendorId,
                    userId,
                    ...formData
                }
                : {
                    projectId: selectedServiceId,
                    projectOwnerId: projects.find(p => p._id === selectedServiceId)?.projectOwnerId,
                    userId,
                    ...formData
                };

            await axios.post(endpoint, payload);

            toast.success("Application submitted! Our representative will contact you soon.");
            setShowModal(false);
            setFormData({ name: '', phone: '', email: '', address: '' });
        } catch (err) {
            console.error("Application submission failed:", err);
            toast.error("Failed to submit application. Please try again.");
        }
    };

    const toggleFilters = () => {
        setShowFilters(!showFilters);
    };

    const getCategoryIcon = (category) => {
        switch(category) {
            case 'Rental': return <FlightIcon className="text-blue-500 mr-2" />;
            case 'Inspection': return <EngineeringIcon className="text-orange-500 mr-2" />;
            case 'Aerial Survey': return <LocationOnIcon className="text-green-500 mr-2" />;
            case 'Crop Spraying': 
            case 'Crop Monitoring': return <AgricultureIcon className="text-lime-500 mr-2" />;
            case 'Photography': return <PhotoCameraIcon className="text-purple-500 mr-2" />;
            case 'Surveillance': return <SecurityIcon className="text-red-500 mr-2" />;
            default: return <AppsIcon className="text-gray-500 mr-2" />;
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
            {/* Hero Section */}
    <div className="relative pt-24 pb-32 overflow-hidden">
  {/* Background image */}
  <img
    src={heroBackground}
    alt="Hero Background"
    className="absolute inset-0 w-full h-full object-cover z-0"
  />

  {/* Gradient overlay from left to 50% */}
  <div className="absolute inset-0 z-10">
    <div className="w-3/4 h-full bg-gradient-to-r from-blue-700/50 "></div>
  </div>

  {/* Grid overlay */}
  <div className="absolute inset-0 bg-grid-white/10 opacity-20 z-20"></div>

  {/* Content container */}
  <div className="container mx-auto px-4 relative z-30">
    <div className="max-w-3xl">
      <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 drop-shadow-lg">
        Drone Services & Projects Marketplace
      </h1>
     <p className="text-xl text-white max-w-[600px] mb-8">
  Connect with professional drone service providers and find exciting drone projects
</p>


      {/* Search bar */}
      <div className="relative rounded-lg overflow-hidden shadow-xl max-w-xl">
        <div className="flex items-center bg-white p-1.5">
          <SearchIcon className="text-gray-500 ml-3 h-5 w-5" />
          <input
            type="text"
            placeholder="Search drone services, projects, vendors..."
            className="flex-grow py-2 px-3 text-gray-700 bg-transparent border-none focus:ring-0 focus:outline-none text-sm"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>
    </div>
  </div>
</div>



            {/* Stats Bar */}
         <div className="container mx-auto px-4 -mt-10 relative z-20">
  <div className="bg-white rounded-lg shadow-md p-4 grid grid-cols-1 md:grid-cols-3 gap-4">
    <div className="flex items-center">
      <div className="bg-blue-100 p-2 rounded-full mr-3">
        <FlightIcon className="text-blue-600 text-xl" />
      </div>
      <div>
        <div className="text-lg font-semibold text-gray-800">{services.length}+</div>
        <div className="text-sm text-gray-600">Drone Services</div>
      </div>
    </div>
    <div className="flex items-center">
      <div className="bg-purple-100 p-2 rounded-full mr-3">
        <WorkIcon className="text-purple-600 text-xl" />
      </div>
      <div>
        <div className="text-lg font-semibold text-gray-800">{projects.length}+</div>
        <div className="text-sm text-gray-600">Active Projects</div>
      </div>
    </div>
    <div className="flex items-center">
      <div className="bg-green-100 p-2 rounded-full mr-3">
        <PersonIcon className="text-green-600 text-xl" />
      </div>
      <div>
        <div className="text-lg font-semibold text-gray-800">150+</div>
        <div className="text-sm text-gray-600">Verified Vendors</div>
      </div>
    </div>
  </div>
</div>
  

            {/* Main Content */}
       <main className="max-w-7xl mx-auto px-4 py-10">
  <div className="grid grid-cols-1 lg:grid-cols-[280px_1fr] gap-6">
    {/* Filter Sidebar */}
    <aside className={`space-y-6 ${showFilters ? 'block' : 'hidden'} lg:block`}>
      <div className="bg-white shadow rounded-xl p-5 sticky top-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold text-gray-900">Filters</h2>
          <button onClick={() => setShowFilters(false)} className="lg:hidden text-gray-400 hover:text-gray-600">
            <CloseIcon fontSize="small" />
          </button>
        </div>

        {/* Category Filter */}
        <section>
          <h3 className="text-sm font-semibold text-gray-700 mb-3">Category</h3> 
          <div className="space-y-2">
            {[
              { name: 'All', icon: <AppsIcon fontSize="small" /> },
              { name: 'Rental', icon: <FlightIcon fontSize="small" /> },
              { name: 'Inspection', icon: <EngineeringIcon fontSize="small" /> },
              { name: 'Aerial Survey', icon: <LocationOnIcon fontSize="small" /> },
              { name: 'Agriculture', icon: <AgricultureIcon fontSize="small" /> },
              { name: 'Photography', icon: <PhotoCameraIcon fontSize="small" /> },
              { name: 'Surveillance', icon: <SecurityIcon fontSize="small" /> },
              { name: 'Others', icon: <AppsIcon fontSize="small" /> },
            ].map((cat) => (
              <button
                key={cat.name}
                onClick={() => setSelectedCategory(cat.name)}
                className={`w-full flex items-center px-3 py-2 rounded-lg text-sm transition font-medium border-l-4 ${
                  selectedCategory === cat.name
                    ? 'bg-blue-50 text-blue-700 border-blue-500'
                    : 'text-gray-600 hover:bg-gray-50 border-transparent'
                }`}
              >
                <span className="mr-2 text-gray-500">{cat.icon}</span>
                {cat.name}
              </button>
            ))}
          </div>
        </section>

        {/* Price Filter */}
        <section>
          <h3 className="text-sm font-semibold text-gray-700 mb-3">Price Range</h3>
          <div className="text-xs text-gray-600 flex justify-between mb-1">
            <span>₹{priceRange[0]}</span>
            <span>₹{priceRange[1]}</span>
          </div>
          <input
            type="range"
            min="0"
            max="75000"
            step="1000"
            value={priceRange[1]}
            onChange={(e) => setPriceRange([priceRange[0], parseInt(e.target.value)])}
            className="w-full h-2 bg-blue-100 rounded-full cursor-pointer"
          />
        </section>

        {/* Sort By */}
        <section>
          <h3 className="text-sm font-semibold text-gray-700 mb-3">Sort By</h3>
          <select
            value={sortOption}
            onChange={(e) => setSortOption(e.target.value)}
            className="w-full border border-gray-200 rounded-lg text-sm p-2 bg-gray-50"
          >
            <option value="newest">Newest First</option>
            <option value="price-low">Price: Low to High</option>
            <option value="price-high">Price: High to Low</option>
          </select>
        </section>

        <button
          onClick={() => setShowFilters(false)}
          className="w-full mt-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm"
        >
          Apply Filters
        </button>
      </div>
    </aside>

    {/* Content */}
    <section>
      {/* Tabs */}
      <div className="flex flex-wrap gap-2 mb-6 border-b border-gray-200">
    {['all', 'services', 'projects', 'pilots'].map((tab) => (
        <button
            key={tab}
            onClick={() => {
                setActiveTab(tab);

                if (tab === 'pilots' && pilots.length === 0) {
                    fetchPilots();
                }
            }}
            className={`px-4 py-2 text-sm rounded-t-lg font-medium ${
                activeTab === tab
                    ? 'bg-blue-50 text-blue-600 border-b-2 border-blue-600'
                    : 'text-gray-600 hover:text-blue-500'
            }`}
        >
            {tab === 'all'
                ? 'All Listings'
                : tab.charAt(0).toUpperCase() + tab.slice(1)}
        </button>
    ))}
</div>

      {/* Summary */}
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-lg font-semibold text-gray-900">
    {activeTab === 'all'
        ? 'All Listings'
        : activeTab === 'services'
        ? 'Drone Services'
        : activeTab === 'projects'
        ? 'Drone Projects'
        : 'Drone Pilots'}
</h2>
          <p className="text-sm text-gray-500">
            {sortedServices.length} services, {sortedProjects.length} projects listed
          </p>
        </div>
        <button
          onClick={toggleFilters}
          className="lg:hidden flex items-center gap-1 px-3 py-1 text-sm bg-white border border-gray-300 rounded-md hover:bg-gray-50"
        >
          <FilterListIcon fontSize="small" /> Filters
        </button>
      </div>

      {/* Listings */}
  {activeTab !== 'projects' && activeTab !== 'pilots' && (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10">
    {sortedServices.map((item) => (
      <div
        key={item._id}
        className="bg-white rounded-xl shadow hover:shadow-lg p-4 transition flex flex-col h-full"
      >
        <div className="flex justify-between items-start mb-2">
          <div>
            <div className="flex items-center text-blue-600 text-xs font-semibold mb-1">
              {getCategoryIcon(item.serviceType)}
              <span className="ml-1">{item.serviceType}</span>
            </div>
            <h3 className="text-lg font-semibold text-gray-800">
              {item.serviceTitle}
            </h3>
          </div>
          <div className="text-md font-bold text-gray-700 text-right">
            {item.pricePerUnit != null && (
              <>
                ₹{item.pricePerUnit.toLocaleString()}
                {item.unitType && <> / {item.unitType}</>}
              </>
            )}
          </div>
        </div>

        <p className="text-sm text-gray-600 mb-3">{item.description}</p>

        <div className="grid grid-cols-2 gap-2 text-sm text-gray-600 mb-4">
          <div className="flex items-center">
            {item.available ? (
              <CheckCircleIcon className="mr-1 text-green-600" />
            ) : (
              <CancelIcon className="mr-1 text-red-500" />
            )}
            <span
              className={
                item.available ? 'text-gray-400' : 'text-red-500'
              }
            >
              {item.available ? 'Available' : 'Not Available'}
            </span>
          </div>
          <div className="flex items-center">
            <LocationOnIcon className="mr-1 text-gray-400" />{' '}
            {item.serviceArea?.city}
          </div>
          <div className="flex items-center">
            <FlightIcon className="mr-1 text-gray-400" /> {item.droneModel}
          </div>
          <div className="flex items-center">
            <EventAvailableIcon className="mr-1 text-gray-400" /> Immediate
          </div>
        </div>

        {/* Apply Button aligned at bottom */}
        <div className="mt-auto pt-2">
          <button
            onClick={() => handleApplyNow(item._id, 'service')}
            className="w-full py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm font-medium flex justify-center items-center"
          >
            <CheckCircleIcon className="mr-1 text-sm" /> Apply
          </button>
        </div>
      </div>
    ))}
  </div>
)}


      {activeTab !== 'services' && activeTab !== 'pilots' && (
        <div className="grid grid-cols-1 gap-4">
          {sortedProjects.map((project) => (
            <div key={project._id} className="bg-white rounded-xl border-l-4 border-purple-500 p-4 shadow hover:shadow-lg transition">
              <div className="flex justify-between items-start mb-3">
                <div>
                  <div className="flex items-center text-purple-600 text-xs font-semibold mb-1">
                    <WorkIcon className="mr-1" /> Project
                  </div>
                  <h3 className="text-lg font-semibold text-gray-800">{project.projectTitle}</h3>
                  <p className="text-lg font-semibold text-gray-800">{project.title}</p>
                </div>
                <div className="text-md font-bold text-gray-700">₹{project.budget?.toLocaleString()}</div>
              </div>
              <p className="text-sm text-gray-600 mb-3">{project.description}</p>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-sm text-gray-600">
                <div className="flex items-center"><LocationOnIcon className="mr-1 text-gray-400" /> {project.location?.city}</div>
                <div className="flex items-center"><EventAvailableIcon className="mr-1 text-gray-400" /> {project.duration} days</div>
                <div className="flex items-center"><EngineeringIcon className="mr-1 text-gray-400" /> {project.skillsRequired?.join(', ') || 'Various'}</div>
                {/* <div className="flex items-center"><PersonIcon className="mr-1 text-gray-400" /> {project.applications || 0} applications</div> */}
              </div>
              <button
                onClick={() => handleApplyNow(project._id, 'project')}
                className="mt-4 w-full py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 text-sm font-medium"
              >
                <CheckCircleIcon className="inline mr-1 text-sm" /> Apply
              </button>
            </div>
          ))}
        </div>
      )}

      {/* ================= PILOTS ================= */}

{activeTab === 'pilots' && (
    <div>

        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
            <div>
                <h3 className="text-xl md:text-2xl font-semibold text-gray-900">
                    Top Drone Pilots
                </h3>

                <p className="text-sm text-gray-500 mt-1">
                    Connect with certified drone pilots for your requirements.
                </p>
            </div>

            <button
                onClick={() => navigate('/pilots')}
                className="px-4 py-2 text-sm font-medium text-blue-600 border border-blue-600 rounded-lg hover:bg-blue-50 transition"
            >
                View All Pilots
            </button>
        </div>

        {/* Loading */}
        {loading.pilots && (
            <div className="flex justify-center items-center py-16">
                <div className="text-sm text-gray-500">
                    Loading pilots...
                </div>
            </div>
        )}

        {/* Pilot Cards */}
        {/* ================= PILOT CARDS ================= */}

{!loading.pilots && pilots.length > 0 && (
  <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 items-start">

    {pilots.slice(0, 3).map((pilot) => (
      <div
        key={pilot._id}
        className="bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-all duration-200 p-5"
      >

        {/* ================= PILOT HEADER ================= */}

        <div className="flex items-center gap-3 mb-4">

          {/* Initial */}
          <div
            className="w-12 h-12 flex-shrink-0 rounded-full flex items-center justify-center text-white text-lg font-bold"
            style={{
              backgroundColor: "#003580",
            }}
          >
            {pilot.name
              ?.charAt(0)
              ?.toUpperCase()}
          </div>

          {/* Name + Category */}
          <div className="min-w-0">

            <h3 className="text-lg font-semibold text-gray-800 truncate">
              {pilot.name}
            </h3>

            <div className="flex items-start gap-1 text-sm text-blue-600 mt-0.5">

              <VerifiedIcon
                sx={{
                  fontSize: 17,
                  marginTop: "2px",
                  flexShrink: 0,
                }}
              />

              <span className="leading-5">
                {pilot.userCategory}
              </span>

            </div>

          </div>

        </div>

        {/* ================= DETAILS ================= */}

        <div className="border-t border-gray-100 pt-3">

          {/* Phone */}
          <div className="flex items-center gap-2 mb-3">

            <PhoneIcon
              sx={{
                fontSize: 18,
                color: "#003580",
                flexShrink: 0,
              }}
            />

            <span
              className="text-sm text-gray-500"
              style={{
                filter: "blur(5px)",
                userSelect: "none",
              }}
            >
              {pilot.number}
            </span>

          </div>

          {/* DGCA */}
          <div className="flex items-center gap-2 mb-3">

            <VerifiedIcon
              sx={{
                fontSize: 19,
                color: "#003580",
                flexShrink: 0,
              }}
            />

            <span className="text-sm font-medium text-gray-600">
              DGCA Certified
            </span>

          </div>

          {/* Location */}
          <div className="flex items-start gap-2">

            <LocationOnIcon
              sx={{
                fontSize: 20,
                color: "#003580",
                flexShrink: 0,
              }}
            />

            <span className="text-sm text-gray-600 leading-5">
              {pilot.district}, {pilot.state}
              <br />
              {pilot.pincode}
            </span>

          </div>

        </div>

        {/* ================= ENQUIRE BUTTON ================= */}

        <button
          onClick={() => handlePilotEnquiry(pilot)}
          className="w-full mt-5 py-2.5 bg-[#003580] text-white rounded-lg hover:bg-[#197a9d] text-sm font-semibold transition-colors"
        >
          Enquire
        </button>

      </div>
    ))}

  </div>
)}

        {/* No pilots */}
        {!loading.pilots && pilots.length === 0 && (
            <div className="text-center py-12">
                <p className="text-gray-500">
                    No pilots found.
                </p>
            </div>
        )}

    </div>
)}


{/* ================= PILOT ENQUIRY MODAL ================= */}

{showPilotEnquiry && (
  <div
    className="fixed inset-0 z-[99999] bg-black/60 px-4 py-4"
    style={{
      overflow: "hidden",
    }}
  >
    <div className="w-full h-full flex items-center justify-center">

      {/* MODAL */}
      <div
        className="relative w-full max-w-lg bg-white rounded-2xl shadow-2xl overflow-hidden"
        style={{
          maxHeight: "calc(100vh - 32px)",
          display: "flex",
          flexDirection: "column",
        }}
      >

        {/* ================= HEADER ================= */}

        <div
          className="bg-gradient-to-r from-blue-600 to-indigo-700 px-6 py-4 flex items-center justify-between"
          style={{
            flexShrink: 0,
          }}
        >
          <div>
            <h2 className="text-lg md:text-xl font-semibold text-white">
              Pilot Enquiry
            </h2>

            {selectedPilot && (
              <p className="text-sm text-blue-100 mt-1">
                Enquiring for {selectedPilot.name}
              </p>
            )}
          </div>

          <button
            type="button"
            onClick={() => setShowPilotEnquiry(false)}
            aria-label="Close"
            className="w-8 h-8 flex items-center justify-center rounded-full bg-white hover:bg-gray-100 transition"
          >
            <CloseIcon
              fontSize="small"
              className="text-gray-700"
            />
          </button>
        </div>

        {/* ================= SCROLLABLE FORM AREA ================= */}

        <div
          style={{
            overflowY: "auto",
            flex: 1,
            minHeight: 0,
          }}
        >
          <form
  onSubmit={submitPilotEnquiry}
  className="px-5 py-4"
>
  {/* NAME */}
  <div className="mb-3">
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Name
    </label>

    <input
      type="text"
      name="name"
      value={pilotEnquiryForm.name}
      onChange={handlePilotEnquiryChange}
      placeholder="Enter your name"
      required
      className="w-full px-3 py-2 rounded-lg border border-gray-300 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
    />
  </div>

  {/* MOBILE */}
  <div className="mb-3">
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Mobile Number
    </label>

    <input
      type="tel"
      name="mobileNumber"
      value={pilotEnquiryForm.mobileNumber}
      onChange={(e) => {
        const value = e.target.value
          .replace(/\D/g, "")
          .slice(0, 10);

        setPilotEnquiryForm((prev) => ({
          ...prev,
          mobileNumber: value,
        }));
      }}
      placeholder="Enter 10 digit mobile number"
      maxLength={10}
      required
      className="w-full px-3 py-2 rounded-lg border border-gray-300 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
    />
  </div>

  {/* EMAIL */}
  <div className="mb-3">
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Email
      <span className="text-gray-400 font-normal">
        {" "} (Optional)
      </span>
    </label>

    <input
      type="email"
      name="email"
      value={pilotEnquiryForm.email}
      onChange={handlePilotEnquiryChange}
      placeholder="Enter your email"
      className="w-full px-3 py-2 rounded-lg border border-gray-300 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
    />
  </div>

  {/* ADDRESS */}
  <div className="mb-3">
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Address
    </label>

    <textarea
      name="address"
      value={pilotEnquiryForm.address}
      onChange={handlePilotEnquiryChange}
      placeholder="Enter your address"
      rows={2}
      required
      className="w-full px-3 py-2 rounded-lg border border-gray-300 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none resize-none"
    />
  </div>

  {/* DESCRIPTION */}
  <div className="mb-3">
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Description
    </label>

    <textarea
      name="description"
      value={pilotEnquiryForm.description}
      onChange={handlePilotEnquiryChange}
      placeholder="Tell us about your requirement..."
      rows={3}
      required
      className="w-full px-3 py-2 rounded-lg border border-gray-300 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none resize-none"
    />
  </div>

  {/* BUTTONS */}
  <div className="flex justify-end gap-3 pt-2">

    <button
      type="button"
      onClick={() => setShowPilotEnquiry(false)}
      disabled={pilotEnquiryLoading}
      className="px-4 py-2 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200 text-sm font-medium transition"
    >
      Cancel
    </button>

    <button
      type="submit"
      disabled={pilotEnquiryLoading}
      className="px-5 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 text-sm font-semibold transition disabled:opacity-60 disabled:cursor-not-allowed"
    >
      {pilotEnquiryLoading
        ? "Submitting..."
        : "Submit Enquiry"}
    </button>

  </div>
</form>
        </div>

      </div>
    </div>
  </div>
)}
    </section>
  </div>
</main>


            {/* Application Modal */}
      {showModal && (
  <div className="fixed inset-0 top-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50 px-4 py-10">
    <div className="relative w-full max-w-lg bg-white rounded-2xl shadow-xl overflow-hidden animate-fadeIn max-h-[auto]">
      {/* Header with reduced height */}
      <div className="bg-gradient-to-r from-blue-600 to-indigo-700 px-5 py-3 flex items-center justify-between">
<h2 className="text-lg font-semibold text-white">
    Apply for {selectedServiceType === 'service' ? 'Drone Service' : 'Drone Project'}
  </h2>
 <button
  onClick={() => setShowModal(false)}
  aria-label="Close modal"
  className="w-8 h-8 flex items-center justify-center rounded-full bg-white hover:bg-gray-200 transition-colors"
>
  <CloseIcon fontSize="small" className="text-gray-900" />
</button>



</div>

      {/* Form without scrollbar */}
      <form onSubmit={handleSubmitApplication} className="px-6 py-6 space-y-5">
        {/* Full Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Full Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            placeholder=""
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            required
          />
        </div>

        {/* Phone + Email */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              placeholder=""
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:outline-none"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder=""
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:outline-none"
              required
            />
          </div>
        </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Offered Price</label>
           <input
            type="text"
            name="offeredPrice"  // this must match the key in your state
            value={formData.offeredPrice}
            onChange={handleInputChange}
            placeholder=""
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            required
            />

          </div>
        {/* Address */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Address</label>
          <textarea
            name="address"
            value={formData.address}
            onChange={handleInputChange}
            placeholder=""
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:outline-none resize-none h-28"
            required
          />
        </div>
       

        {/* Action Buttons */}
        <div className="flex justify-end gap-4 pt-3">
          <button
            type="button"
            onClick={() => setShowModal(false)}
            className="px-5 py-2.5 rounded-lg text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 transition"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-6 py-2.5 rounded-lg text-sm font-semibold text-white bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 shadow-md transition"
          >
            Submit Application
          </button>
        </div>
      </form>
    </div>
  </div>
)}



        </div>
    );
}

export default DaasMarketplace;